import { render, staticRenderFns } from "./magicshow.vue?vue&type=template&id=1af88f5a&scoped=true&"
import script from "./magicshow.vue?vue&type=script&lang=js&"
export * from "./magicshow.vue?vue&type=script&lang=js&"
import style0 from "./magicshow.vue?vue&type=style&index=0&id=1af88f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af88f5a",
  null
  
)

export default component.exports